// Copyright (c) 2023 WiseTime. All rights reserved.

import { Metadata } from "grpc-web"

export const injectTimelineVersionMetadata = (metadata: Metadata): void => {
  // eslint-disable-next-line lingui/no-unlocalized-strings
  const timelineVersionKey = "X-Timeline-Version"
  const buildInfoId = "build-info"
  metadata[timelineVersionKey] = document.getElementById(buildInfoId)?.textContent ?? ""
}
